export default __webpack_public_path__ + "static/media/contact.e55ae0ae.png";